/**
 * SA-1129: the ids that tie the Inbox view tabs to the panel they control,
 * kept out of `InboxViewTabs.tsx` so that file exports its component only
 * (`react-refresh/only-export-components`).
 */
import type { InboxViewTab } from '@/types/inbox'

/** The list column's id: the page marks it `role="tabpanel"`. One Inbox per page. */
export const INBOX_VIEW_PANEL_ID = 'inbox-view-panel'
export const inboxViewTabId = (tab: InboxViewTab) => `inbox-view-tab-${tab}`
